export default __webpack_public_path__ + "static/media/m-service1.fd5d53b5.svg";